import classNames from 'classnames'
import { ReactElement } from 'react'
import { RecipeSections } from 'app/components/lists/card/RecipeSections'
import { recipeFromConfig } from 'lib/cardRecipe'
import type { CommContext } from 'app/hooks/usePipelineCommContext'
import type { TaskCounts } from 'app/hooks/usePipelineTaskCounts'
import type { ListCardConfig } from 'lib/listCardConfig'
import type { ContactJson } from 'app/types/entities'

export function ContactSlotCard({
  contact,
  config,
  taskCounts,
  commContext,
  dimmed = false,
  cursor = `pointer`,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
}: {
  contact: ContactJson
  config: ListCardConfig
  taskCounts?: TaskCounts
  commContext?: CommContext
  /** True while this card is the one being dragged. */
  dimmed?: boolean
  cursor?: `pointer` | `grabbing`
  onMouseDown?: () => void
  onMouseUp?: () => void
  onMouseLeave?: () => void
}): ReactElement {
  const compact = config.density === `compact`

  return (
    <div
      className={classNames(`flex flex-col justify-between rounded-lg shadow-elevation-2`, compact ? `pt-2` : `pt-3`)}
      // oxlint-disable-next-line shadcn/no-inline-styles -- moved verbatim under a parity snapshot, G3 replaces this card
      style={{ opacity: dimmed ? 0.1 : 1, cursor }}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
    >
      <RecipeSections
        recipe={recipeFromConfig(config)}
        subject={{ kind: `contact`, contact }}
        context={{ taskCounts, commContext }}
      />
    </div>
  )
}
